import { Pipe } from '@angular/core';
import { map } from 'rxjs';

import type { PipeTransform } from '@angular/core';
import type { TiiaModel } from '@kp/interfaces';
import type { Observable } from 'rxjs';

@Pipe({ name: 'kpZeroDiscount' })
class ZeroDiscountPipe implements PipeTransform {
  transform(model$: Observable<TiiaModel>): Observable<boolean> {
    return model$.pipe(
      map(model => isZeroDiscountReferral(model.additionalAgreementInfo)),
    );
  }
}

/**
 * Return whether referral is BAPO, TC or not
 */
function isZeroDiscountReferral(
  agreement: TiiaModel['additionalAgreementInfo'],
): boolean {
  return ['KB_BAPO', 'KB_TC'].includes(agreement.referralCode || '');
}

export { isZeroDiscountReferral, ZeroDiscountPipe };
